import React, { useCallback, useMemo, useState } from "react";
import CountUp from "react-countup";
import { Month } from "../../../../domain/fundamental/Month";
import { useFilteredLoginLogList } from "../../../hooks/admin/login_log/useFilteredLoginLogList";
import { AdminMonthPicker } from "../AdminMonthPicker";


export const LoginLogMonthlyTotal = React.memo(function LoginLogMonthlyTotal() {
    const { loginLogList } = useFilteredLoginLogList();

    const [selectedMonth, setSelectedMonth] = useState<Month>(Month.thisMonth());

    const whenDateChanged = useCallback((month: Month | null) => {
        if (month) setSelectedMonth(month);
    }, []);

    const total = useMemo(() => 
        loginLogList.filter(loginLog => loginLog.time.date.getMonth().equals(selectedMonth)).length,
    [loginLogList, selectedMonth]);

    return (
        <div className={"total_area"}>
            {/* カレンダー */}
            <AdminMonthPicker currentMonth={selectedMonth} whenDateChanged={whenDateChanged} />
            {/* 合計 */}
            <div className={"total_count_card"}>
                <div className={"label"}>合計ログイン数</div>
                <div className={"count"}>
                    <CountUp start={0} end={total} duration={0.2} suffix="回" useEasing={false} />
                </div>
            </div>
        </div>
    );
});
